import Input from '../Input'

export default function RenderInputWithLabel({ label, type, placeholder, defaultValue, className, inputClassNames, value, name, onChange, disabled }) {

  return (

    <div className={className}>

      <label className='mb-2 block font-medium text-[var(--secondary)] text-[18px]'>{label}</label>

      <Input classNames={inputClassNames} onChange={onChange} disabled={disabled} value={value} name={name} inputType={type} defaultValue={defaultValue} placeholder={placeholder} />

    </div>

  )
}